module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUAgMAAADEnjSCAAAADFBMVEUAAAD///////////84wDuoAAAAA3RSTlMAFdPSGaGkAAAALUlEQVQI12MQYWBgyATiPAcGBukJDAxsTxgYGHdiCIAwiA0SA8mhccFmgMwCAALeDO/t/b0RAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/fx/orderArrow_white.png
// module id = xsSX
// module chunks = 0